<template>
  <div>
    <router-view v-if="$auth.ready()"></router-view>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  methods: {
    bootstrap() {
      this.$store.dispatch('SetDarkMode', Vue.ls.get('DARK_MODE', true))
      this.$store.dispatch('SetLocale', Vue.ls.get('LOCALE', 'en'))
    }
  },
  watch: {
    "$store.state.app.darkMode"(on) {
      let docClasses = document.body.classList;
      if (on) {
        docClasses.remove('white-content');
      } else {
        docClasses.add('white-content');
      }
    },
    "$store.state.app.locale"(locale) {
      this.i18n = this.$i18n;
      this.i18n.locale = locale;
    },
    '$route'(to, from) {
      document.title = this.$t(`router.${to.meta.title}`) || 'Main panel'
    }
  },
  created() {
    this.bootstrap();
  }
};
</script>
<style lang="scss">
@import "./src/assets/sass/dashboard/custom/_variables.scss";

.cursor-pointer {
  cursor: pointer;
}

/* Table summary highlighted background. */
.el-table__footer-wrapper tbody td, .el-table__header-wrapper tbody td {
  background-color: $body-bg !important;
}

.total_row {
  background-color: $body-bg;
}

.el-table__expanded-cell[class*=cell] {
  background-color: $body-bg;

  &:hover {
    background-color: $body-bg !important;
  }
}

/* Table summary cell text appearance. */
.el-table__footer .cell, .total_row {
  font-weight: $font-weight-bold;
}

/* Table intermediate summary appearance. */
.intermediate_total_row {
  font-weight: $font-weight-bold;
}

/*.modal-body {*/
/*  padding: 0;*/

/*.card {*/
/*  padding: $modal-inner-padding;*/
/*  margin: 0;*/
/*}*/
/*}*/

table.table-details {
  width: auto;
  margin: 0;

  tbody tr, tr {
    td:first-of-type {
      padding: 0 1rem 0 1rem;
    }

    td {
      padding: 0 1rem 0 0;
    }
  }


  /*th,*/
  /*td,*/
  /*thead th,*/
  /*tbody + tbody {*/
  /*  !*vertical-align: middle;*!*/
  /*}*/

  label {
    margin: 0;
  }
}

table.table-report {
  width: auto;
  margin: 0;
  color: inherit !important;

  tbody tr, tr {
    td:first-of-type {
      padding: 0.25rem 1rem 0.25rem 1rem;
    }

    td {
      padding: 0.25rem 1rem 0.25rem 0;
    }
  }


  /*th,*/
  /*td,*/
  /*thead th,*/
  /*tbody + tbody {*/
  /*  !*vertical-align: middle;*!*/
  /*}*/

  label {
    margin: 0;
  }
}

.cell {
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}

.el-range-input {
  background-color: transparent;
}

.pagination-select {
  width: 100px;
}

.search-input {
  width: 200px;
}

.special_row {
  background-color: $special_row !important;
}

.active_row {
  background-color: $success-opacity !important;
}

.zi_100 {
  z-index: 100
}
</style>
